import React, { useEffect, useState } from 'react';
import axios from 'axios';
import XMLParser from 'react-xml-parser';
import { Helmet } from 'react-helmet';

const App = () => {
    const [rssData, setRssData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRSS = async () => {
            try {
                const response = await axios.get('https://mpinfo.org/RSSFeed/RSSFeed_News.xml', {
                    headers: {
                        'Content-Type': 'application/xml',
                    }
                });

                const xml = response.data;
                const parsedXml = new XMLParser().parseFromString(xml);

                const items = parsedXml.getElementsByTagName('item');
                const newsItems = items.map(item => ({
                    title: item.getElementsByTagName('title')[0].value,
                    link: item.getElementsByTagName('link')[0].value,
                }));

                setRssData(newsItems);
            } catch (err) {
                setError('Failed to fetch RSS feed');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchRSS();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <>
            <Helmet>
                <title>जनसंपर्क समाचार – सरकारी योजनाएं और सरकारी अपडेट | ShabdToday</title>

                <meta name="title" content="आज की जनसंपर्क विभाग की बड़ी खबरें हिंदी में | सरकारी योजनाओं की ताज़ा घोषणाएँ" />
                <meta
                    name="description"
                    content="आज की जनसंपर्क विभाग की ताज़ा खबरें हिंदी में। सरकारी योजनाओं, नई घोषणाओं और देश-दुनिया के जनसंपर्क अभियानों की नवीनतम हिंदी समाचार अपडेट।" />
                <meta name="keywords" content="जनसंपर्क विभाग खबरें, सरकारी योजनाओं की खबर, जनसंपर्क अभियान अपडेट, जनसंपर्क विभाग समाचार, हिंदी सरकारी न्यूज़, नई सरकारी घोषणाएँ, देश दुनिया जनसंपर्क खबरें, हिंदी पब्लिक रिलेशन न्यूज़" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="ShabdToday Team" />

                <link rel="canonical" href="https://shabdtoday.com/jansampark" />

                <meta property="og:title" content="जनसंपर्क समाचार – सरकारी योजनाएं और अपडेट | ShabdToday" />
                <meta
                    property="og:description"
                    content="सरकारी योजनाओं, विभागीय नोटिस, लाभ और जनसंपर्क विभाग से जुड़ी ताज़ा खबरें हिंदी में।"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://shabdtoday.com/jansampark" />
                <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "name": "जनसंपर्क समाचार – ShabdToday",
                        "url": "https://shabdtoday.com/jansampark",
                        "description": "सरकारी विभाग, योजनाएं और जनसंपर्क विभाग से संबंधित ताज़ा अपडेट हिंदी में।",
                        "publisher": {
                            "@type": "Organization",
                            "name": "ShabdToday",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://shabdtoday.com/design/images/logo-s.webp"
                            }
                        }
                    })}
                </script>


            </Helmet>
            {/* <h1 className="visually-hidden">जनसंपर्क से जुड़ी ताज़ा खबरें</h1>
            <h2 className="visually-hidden">सरकारी योजनाएं और विभागीय अपडेट</h2>
            <h3 className="visually-hidden">नोटिफिकेशन | घोषणाएं | सरकारी लाभ</h3> */}
            <div style={styles.container}>
                <h1 style={styles.heading}>MP जनसंपर्क फीड (जनसंपर्क से जुड़ी ताज़ा खबरें)</h1>
                {/* Using ul with styled bullets */}
                <ul style={styles.newsList}>
                    {rssData.map((item, index) => (
                        <li key={index} style={styles.newsItem}>
                            <a
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={styles.link}
                            >
                                <h2>{item.title}</h2>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

const styles = {
    container: {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f4f4f9',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '100%',
        margin: '0 auto',
    },
    heading: {
        color: '#333',
        fontSize: '28px',
        fontWeight: '1000',
        marginBottom: '20px',
    },
    // newsList: {
    //     listStyleType: 'disc',
    //     listStylePosition: 'inside',
    //     paddingLeft: '20px',
    //     margin: '0',
    //     color: 'crimson',
    //     fontSize: '18px',
    // },
    newsItem: {
        marginBottom: '10px',
        fontSize: '16px',
        lineHeight: '1.6',
        paddingLeft: '5px',
        paddingRight: '5px',
        background: 'rgba(0, 0, 0, 0.05)', // Light background for visibility
        border: '1px solid #ddd',           // Border for clearer structure
    },
    link: {
        textDecoration: 'none',
        color: 'crimson',
        fontWeight: 'bold',
    },
    newsItem: {
        marginBottom: '10px',
        fontSize: '15px',
        lineHeight: '1.6',
        paddingLeft: '20px',
        background: 'rgba(0, 0, 0, 0.06)',
        border: '1px solid #ddd',
        listStyleType: 'disc',
        color: 'crimson',
    }
};

export default App;
